import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getShift({page = "page=1",term = ""}) {
  const data = await getFetch(`/shifts?term=${term}&${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeShift(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'شیفت الزامی است!',
    }
  }

  const res = await postFetchWithToken("/shifts/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'شیفت با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}
async function deleteShift(id) {
  const res = await postFetchWithBody(`/shifts/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getShift, storeShift,deleteShift };
